/**
 * Brand asset registry — responsive AVIF/WebP/PNG variants for logos.
 *
 * Generated by /tmp/logopipe/pipeline.py (5 widths × 3 formats per asset).
 * PNG fallback is required for very old User-Agents (WebP: universal since 2020,
 * AVIF: Safari 16+ / Chrome 85+ / Firefox 93+). BrandMark serves them via a
 * `<picture>` element with format-negotiation in decreasing preference:
 * AVIF → WebP → PNG.
 */
import wordmark240Avif from "./brand/wordmark-240.avif.asset.json";
import wordmark240Webp from "./brand/wordmark-240.webp.asset.json";
import wordmark240Png from "./brand/wordmark-240.png.asset.json";
import wordmark400Avif from "./brand/wordmark-400.avif.asset.json";
import wordmark400Webp from "./brand/wordmark-400.webp.asset.json";
import wordmark400Png from "./brand/wordmark-400.png.asset.json";
import wordmark600Avif from "./brand/wordmark-600.avif.asset.json";
import wordmark600Webp from "./brand/wordmark-600.webp.asset.json";
import wordmark600Png from "./brand/wordmark-600.png.asset.json";
import wordmark900Avif from "./brand/wordmark-900.avif.asset.json";
import wordmark900Webp from "./brand/wordmark-900.webp.asset.json";
import wordmark900Png from "./brand/wordmark-900.png.asset.json";
import wordmark1200Avif from "./brand/wordmark-1200.avif.asset.json";
import wordmark1200Webp from "./brand/wordmark-1200.webp.asset.json";
import wordmark1200Png from "./brand/wordmark-1200.png.asset.json";

import mark96Avif from "./brand/mark-96.avif.asset.json";
import mark96Webp from "./brand/mark-96.webp.asset.json";
import mark96Png from "./brand/mark-96.png.asset.json";
import mark128Avif from "./brand/mark-128.avif.asset.json";
import mark128Webp from "./brand/mark-128.webp.asset.json";
import mark128Png from "./brand/mark-128.png.asset.json";
import mark192Avif from "./brand/mark-192.avif.asset.json";
import mark192Webp from "./brand/mark-192.webp.asset.json";
import mark192Png from "./brand/mark-192.png.asset.json";
import mark256Avif from "./brand/mark-256.avif.asset.json";
import mark256Webp from "./brand/mark-256.webp.asset.json";
import mark256Png from "./brand/mark-256.png.asset.json";
import mark384Avif from "./brand/mark-384.avif.asset.json";
import mark384Webp from "./brand/mark-384.webp.asset.json";
import mark384Png from "./brand/mark-384.png.asset.json";

type Variant = { url: string; w: number };
type Set = { avif: Variant[]; webp: Variant[]; png: Variant[]; intrinsic: { w: number; h: number } };

const v = (a: { url: string }, w: number): Variant => ({ url: a.url, w });

export const WORDMARK: Set = {
  intrinsic: { w: 1560, h: 570 }, // aspect ≈ 2.74:1
  avif: [v(wordmark240Avif, 240), v(wordmark400Avif, 400), v(wordmark600Avif, 600), v(wordmark900Avif, 900), v(wordmark1200Avif, 1200)],
  webp: [v(wordmark240Webp, 240), v(wordmark400Webp, 400), v(wordmark600Webp, 600), v(wordmark900Webp, 900), v(wordmark1200Webp, 1200)],
  png: [v(wordmark240Png, 240), v(wordmark400Png, 400), v(wordmark600Png, 600), v(wordmark900Png, 900), v(wordmark1200Png, 1200)],
};

export const MARK: Set = {
  intrinsic: { w: 500, h: 500 },
  avif: [v(mark96Avif, 96), v(mark128Avif, 128), v(mark192Avif, 192), v(mark256Avif, 256), v(mark384Avif, 384)],
  webp: [v(mark96Webp, 96), v(mark128Webp, 128), v(mark192Webp, 192), v(mark256Webp, 256), v(mark384Webp, 384)],
  png: [v(mark96Png, 96), v(mark128Png, 128), v(mark192Png, 192), v(mark256Png, 256), v(mark384Png, 384)],
};

export const srcSet = (list: Variant[]) => list.map((x) => `${x.url} ${x.w}w`).join(", ");
